(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('view-all-command-value', {
                parent: 'management',
                url: '/view-all-command-value',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: ''
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/management/commands/view-all-commands-value.html',
                        controller: 'viewAllCommandsValueController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    fleet: {
                        value: '-1',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    }

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates : $stateParams.predicates,
                            filter: $stateParams.listFilter,
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('actionCommands');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
